import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useSearchParams from './useSearchParams';

export const useTabSearchParam = <T extends string>(key: string, defaultValue: T) => {
  const { search } = useLocation();
  const { setSearchParams } = useSearchParams();

  const value = useMemo<T>(() => {
    const raw = new URLSearchParams(search).get(key);
    return (raw as T) || defaultValue;
  }, [search, key, defaultValue]);

  const setValue = useCallback(
    (next: T) => {
      setSearchParams({ [key]: next === defaultValue ? undefined : next });
    },
    [setSearchParams, key, defaultValue],
  );

  return [value, setValue] as const;
};
